import {Component, OnInit} from '@angular/core';
import {FuseConfigService} from '../../../@fuse/services/config.service';

@Component({
    selector: 'mb-reset-layout',
    templateUrl: './reset-layout.component.html',
    styleUrls: ['./reset-layout.component.scss']
})
export class ResetLayoutComponent implements OnInit {

    showButton: boolean;

    constructor(private fuseConfigService: FuseConfigService) {
    }

    resetLayout(): void {
        this.fuseConfigService.config = {
            layout: {
                toolbar: {
                    hidden: false
                }
            }
        };
    }

    showLayoutButton(): void {
        this.showButton = true;
    }

    hideLayoutButton(): void {
        this.showButton = false;
    }

    ngOnInit(): void {
    }

}
